import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class BranchCreditService {

    getBranchCreditList(keyword, start) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = '/api/branch_credit_list';
        const formData = new FormData();
        formData.append('keyword', keyword);
        formData.append('start', start);
        return instance()(
            {
                method: 'post',
                url: api,
                data: formData,
            }
        ).then(res => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            })
    }

    getHistory(branchId, start = 0) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = '/api/branch_credit_history/' + branchId;
        return instance().get(api, {
                params: { start: start }
            })
            .then(res => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            })
    }
}